import { render, staticRenderFns } from "./fieldRightSetting.vue?vue&type=template&id=50b338f3&scoped=true"
import script from "./fieldRightSetting.vue?vue&type=script&lang=js"
export * from "./fieldRightSetting.vue?vue&type=script&lang=js"
import style0 from "./fieldRightSetting.vue?vue&type=style&index=0&id=50b338f3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b338f3",
  null
  
)

export default component.exports